import { withI18n } from '@lingui/react'
import { oneOf, string } from 'prop-types'

import Collapsible from 'views/components/organisms/Collapsible'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import { ProductType } from 'views/utils/propTypes'
import { pickRequired } from 'views/utils/propTypeUtils'

import './ProductConsultation.scss'

import ProductConsultationCallback from './ProductConsultationCallback'
import { ORDER_TYPE, PRODUCT_TYPE } from './ProductConsultationCallback/helpers'
import ProductConsultationDirect from './ProductConsultationDirect'
import ProductConsultationMessage from './ProductConsultationMessage'

const ProductConsultation = ({ name, id, i18n, title, type }) => (
  <article className="o-ProductConsultation">
    <p className="o-ProductConsultation__text">
      <TransWithHtml id={title} values={{ name }} />
    </p>
    <ul className="a-list-reset o-ProductConsultation__list">
      <li className="o-ProductConsultation__item">
        <Collapsible
          label={i18n._('product.consultation.direct.title')}
          id={`consultation.direct.${id}`}
          alwaysDisplayHeading
          allScreensizes
          expanded
          light
          position="first"
          inModal
        >
          <ProductConsultationDirect />
        </Collapsible>
      </li>
      <li className="o-ProductConsultation__item">
        <Collapsible
          label={i18n._('product.consultation.callback.title')}
          id={`consultation.callback.${id}`}
          alwaysDisplayHeading
          allScreensizes
          light
          position="middle"
          inModal
          forceDisplayWhenCollapsed
        >
          <ProductConsultationCallback
            name={name}
            id={id}
            type={type}
            headlineTranslationKey="product.consultation.callback.headline"
          />
        </Collapsible>
      </li>
      <li className="o-ProductConsultation__item">
        <Collapsible
          label={i18n._('product.consultation.message.title')}
          id={`consultation.email.${id}`}
          alwaysDisplayHeading
          allScreensizes
          light
          position="last"
          inModal
          forceDisplayWhenCollapsed
        >
          <ProductConsultationMessage
            scope="product-consultation"
            productId={id}
            productName={name}
            type={type}
          />
        </Collapsible>
      </li>
    </ul>
  </article>
)

ProductConsultation.propTypes = {
  ...pickRequired(ProductType, ['name', 'id']),
  title: string,
  type: oneOf([PRODUCT_TYPE, ORDER_TYPE]),
}

ProductConsultation.defaultProps = {
  title: 'product.consultation.headline',
  type: PRODUCT_TYPE,
}

export default withI18n()(ProductConsultation)
